export const ADD_GRE_STARTED =
  'ADD_GRE_STARTED';
export const ADD_GRE_SUCCESS =
  'ADD_GRE_SUCCESS';
export const ADD_GRE_ENDED = 'ADD_GRE_ENDED';
export const ADD_GRE_ERROR = 'ADD_GRE_ERROR';
